import React from "react";
import AccountLinkingPricingExample, { PricingData } from "../../dialogs/enable-paid-features/AccountLinking";
import MultiTenancyPricingCard, { MultiTenancyConfig } from "../../dialogs/enable-paid-features/MultiTenancy";
import AdditionalUsers, { AdditionalUsersConfig } from "../../dialogs/enable-paid-features/AdditionalUsers";
import { LicenseKeyFeaturesList } from "../../../api/st/features/get";

export const clientSideOnlyFeatureList: LicenseKeyFeaturesList = [
    {
        featureId: "security",
        featureName: "Attack protection suite",
        minVersionXY: "9.0"
    }
];

export const featureIDToPricingConfig = {
    account_linking: {
        hasDialog: true,
        dialog: AccountLinkingPricingExample,
        dialogConfig: [
            {
                mauRange: "1 - 10,000",
                price: "$100 / month"
            },
            {
                mauRange: "10,001",
                calculation: "($0.01 * 10,001)",
                price: "$100.1 / month"
            },
            {
                mauRange: "15,000",
                calculation: "($0.01 * 15,000)",
                price: "$150 / month"
            }
        ] as PricingData[],
        pricing: {
            type: "FIXED",
            value: "0.01",
            minimumBilling: "100",
            unit: "MAU",
            text: "$0.01 / MAU"
        },
        type: "ACCOUNT_LINKING"
    },
    multi_tenancy: {
        hasDialog: true,
        dialog: MultiTenancyPricingCard,
        dialogConfig: {
            pricingSections: [
                {
                    header: "Email password, Social, Passwordless login",
                    pricingDetails: [
                        {
                            highlight: { text: "Less than 5 users / tenant", color: "grey" },
                            description: (
                                <span>
                                    Free for 25 tenants, <span className="multitenancy-price-highlight">$2</span> /
                                    tenant / month after that.
                                </span>
                            )
                        },
                        {
                            highlight: { text: "5 or more users / tenant", color: "grey" },
                            description: (
                                <span>
                                    <span className="multitenancy-price-highlight">$5</span> / tenant / month
                                </span>
                            )
                        }
                    ]
                },

                {
                    pricingDetails: [
                        {
                            highlight: { text: "Enterprise SSO", color: "yellow" },
                            description: (
                                <span>
                                    <span className="multitenancy-price-highlight">$50</span> / tenant / month
                                </span>
                            )
                        }
                    ]
                },

                {
                    pricingDetails: [
                        {
                            highlight: { text: "Additional App/Env.", color: "yellow" },
                            description: (
                                <span>
                                    <span className="multitenancy-price-highlight">$50</span> / app / month
                                </span>
                            )
                        }
                    ]
                }
            ],

            link: { text: "See pricing example", url: "/pricing" }
        } as MultiTenancyConfig,
        pricing: {
            type: "INFO",
            text: "See info"
        },
        type: "MULTI_TENANCY"
    },
    dashboard_login: {
        hasDialog: true,
        dialog: AdditionalUsers,
        dialogConfig: {
            numberOfFreeUsers: 3
        } as AdditionalUsersConfig,
        pricing: {
            type: "FIXED",
            value: "20",
            text: "$20 / user / month",
            unit: "user/month"
        },
        type: "DASHBOARD_LOGIN"
    },

    mfa: {
        hasDialog: false,
        pricing: {
            type: "FIXED",
            value: "0.02",
            minimumBilling: "100",
            unit: "MAU",
            text: "$0.02 / MAU"
        },
        type: "MFA"
    },
    security: {
        hasDialog: false,
        pricing: {
            type: "CUSTOM",
            text: "Contact Us",
            mail: "support@supertokens.com"
        },
        type: "ATTACK_PROTECTION_SUITE"
    }
} as const;
